module.exports = __webpack_public_path__ + "assets/165b7197541f6d777b873bffab92dd28.png";